<template>
    <div v-if="showAlert">
        <div class="alert alert-danger alert-dismissible fade show">
            {{message}}
        </div>
    </div>
</template>
<script>
export default {
    name: 'alert',
    data(){
        return {
            showAlert: false,
            message: null
        }
    },
    methods: {
        show() {
            this.showAlert = true;
        },
        hide(){
            this.showAlert = false;
        }
    }
}
</script>
<style>
@media screen and (max-width: 600px)
{
.alert{
    position: fixed;
    top:0;
    width: 100%;
    /* left: 10%; */
    z-index: 50;
    margin:auto;

}
}
</style>



// WEBPACK FOOTER //
// src/components/steps/custom/alert.vue